/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityInfo
 */
export interface FacilityInfo {
    /**
     * Facility name
     */
    name: string;
    /**
     * Alternative names for the facility that insurance representatives may recognize
     */
    alternative_names?: Array<string>;
    /**
     * Facility tax ID
     */
    tax_id: string;
    /**
     * Facility NPI number
     */
    npi: string;
    /**
     * Facility address
     */
    address: string;
    /**
     * Facility state code
     */
    state: string;
}

/**
 * Check if a given object implements the FacilityInfo interface.
 */
export function instanceOfFacilityInfo(value: object): value is FacilityInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tax_id' in value) || value['tax_id'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function FacilityInfoFromJSON(json: any): FacilityInfo {
    return FacilityInfoFromJSONTyped(json, false);
}

export function FacilityInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'alternative_names': json['alternative_names'] == null ? undefined : json['alternative_names'],
        'tax_id': json['tax_id'],
        'npi': json['npi'],
        'address': json['address'],
        'state': json['state'],
    };
}

export function FacilityInfoToJSON(json: any): FacilityInfo {
    return FacilityInfoToJSONTyped(json, false);
}

export function FacilityInfoToJSONTyped(value?: FacilityInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'alternative_names': value['alternative_names'],
        'tax_id': value['tax_id'],
        'npi': value['npi'],
        'address': value['address'],
        'state': value['state'],
    };
}

